import React, { useRef, useEffect, useState } from "react";
import { Cookies } from "react-cookie";
import { config } from "../../../app-config";
import { AiOutlineShopping, AiOutlineDelete } from 'react-icons/ai';
import { FaTrash, FaRegTrashAlt, FaBox, FaStore, FaRegBookmark, FaTruck } from 'react-icons/fa';
import { RiShoppingCart2Line } from "react-icons/ri";
import {
  Div,
  Divider,
  FlexColumn,
  FlexRow,
  Spacer,
} from "../../../core/Containers";
import { Image } from "../../../core/Image";
import { Span, Text } from "../../../core/Text";
import { ColumnHeader } from "../../../components/Tables";
import { Button, RawButton, RawDropdown, ButtonShadow } from "../../../core/Buttons";
import { ImUpload3, ImInfo, ImSpinner2 } from "react-icons/im";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CheckBox, FileInput, RawInput, RawSelect } from "../../../core/Forms";
import { HiCheckCircle } from "react-icons/hi";
import { FaTimes, FaTimesCircle } from "react-icons/fa";
import { Loading } from "../../Window/Loading";
import { LBCModal, LBCModalTwoFunc } from "../../../components/Modals/LBCModal";
import { useCallbackPrompt } from "../../../hooks";
import moment from "moment";
import Barcode from "react-barcode";
import QRCode from "qrcode.react";
import { getPayCollectOptn } from "../../../helpers/common";
import { useDropzone } from "react-dropzone";
import { PackageCard } from "../../../components/Feature/PackageItem";
import NPouchRegular from "../../../assets/images/sendtipid-pckgs/N-Pouch-Regular.png";
import NPouchExtraLarge from "../../../assets/images/sendtipid-pckgs/N-Pouch-XL.png";
import NPouchSuperLarge from "../../../assets/images/sendtipid-pckgs/N-Pouch-SS.png";
import NPackSmall from "../../../assets/images/sendtipid-pckgs/N-Pack-Small.png";
import NPackLarge from "../../../assets/images/sendtipid-pckgs/N-Pack-Large.png";
import KiloBoxSmall from "../../../assets/images/sendtipid-pckgs/Kilobox-Small.png";
import KiloBoxMeduim from "../../../assets/images/sendtipid-pckgs/Kilobox-Medium.png";
import Path1 from "../../../assets/images/sendtipid-pckgs/path1.png";
import Path2 from "../../../assets/images/sendtipid-pckgs/path2.png";
import { CartModal } from "../../../components/Modals/CartModal";
import ConfirmImage from "../../../assets/images/sendtipid-pckgs/sendtipidConfirmBooking.png";
import LogoLBC from "../../../assets/images/lbclogo.png";
import { Tab } from "@headlessui/react";
import { SendTipidBookingStage } from "../../../constants/ConstantsData";
import { StageUISendTipid } from "../../../components/Feature";
import { Images } from "../../../assets/images/images";
import { BsCash } from "react-icons/bs";
import { IoQrCodeSharp } from "react-icons/io5";
import { FaCreditCard } from "react-icons/fa";
import { TfiWallet } from "react-icons/tfi";
import { AddressBookSendTipidModal } from "../../../components/Modals/AddressBookSendTipidModal";
import BookNow from "../../../services/BookNow.service";
import {
  getProvinceRegionId,
  isNumber,
  isMobileNumber,
  getCAMSProdId,
} from "../../../helpers/common";

import axiosCAPApiPrivate from "../../../api/axiosCAPApiPrivate";
import axiosLexaApiPrivate from "../../../api/axiosLexaApiPrivate";
import axiosCommonRefApi from "../../../api/axiosCommonRefApi";

import { OrderModal } from '../../../components/Modals/OrderModal';
import { use } from "react";

const cookies = new Cookies();
const filterConfig = {
  ignoreCase: true,
  ignoreAccents: true,
  trim: true,
  matchFrom: "any",
  stringify: (option) => `${option.label}`,
};

export const SendTipidBookTab = ({
  selectedTab,
  blkSessionId,
  data,
  isOpen,
}) => {
  const [dateSubmitted, setDateSubmitted] = React.useState(
    moment(new Date()).format("MMMM Do YYYY, h:mm:ss a")
  );
  
  const navigate = useNavigate();
  const dataFetchedRef = useRef(false);
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const actionQuery = query.get("booking");

  const [bookType, setBookType] = React.useState("default");
  const [bookAdded, setBookAdded] = React.useState(false);

  const [loading, setLoading] = React.useState(false);
  const [loading2, setLoading2] = React.useState(false);
  const [isToastOpenA, setToastOpenA] = React.useState(false);
  const [isToastOpenB, setToastOpenB] = React.useState(false);
  const [isCartOpen, setCartOpen] = React.useState(false);

  const inputFileRef = React.useRef(null);
  const [file, setFile] = React.useState([{ name: "browse", size: 0 }]);
  const [prevFile, setPrevFile] = React.useState([{ name: "browse", size: 0 }]);
  const [uploaded, setUpload] = React.useState(false);
  const [uploadFile, setUploadFile] = React.useState("");

  const [isToastOpen, setToastOpen] = React.useState(false);
  const [toastKind, setToastKind] = React.useState("");
  const [toastTitle, setToastTitle] = React.useState("");
  const [toastDesc, setToastDesc] = React.useState("");

  const [isToastOpen1, setToastOpen1] = React.useState(false);

  const [isToastOpen2, setToastOpen2] = React.useState(false);
  const [toastKind2, setToastKind2] = React.useState("");
  const [toastTitle2, setToastTitle2] = React.useState("");
  const [toastDesc2, setToastDesc2] = React.useState("");

  const [isToastOpen3, setToastOpen3] = React.useState(false);
  const [toastTitle3, setToastTitle3] = React.useState("");
  const [toastDesc3, setToastDesc3] = React.useState("");

  const [bulkSessionId, setBulkSessionId] = React.useState("");

  const [shipperAcctName, setShipperAcctName] = React.useState("");
  const [shipperAcctNo, setShipperAcctNo] = React.useState("");

  const [bulkDetailsData, setBulkDetailsData] = React.useState([]);
  const [validData, setValidData] = React.useState(true);
  const [updatedItemId, setUpdatedItemId] = React.useState(0);
  const [selectedItem, setSelectedItem] = React.useState(null);

  const [agreementAccepted, setAgreementAccepted] = React.useState(false);

  const [selected, setSelected] = React.useState("default");
  const [selectedList, setSelectedList] = React.useState([]);
  const [requestSubmitted, setRequest] = React.useState(false);
  const [pkgData, setPkgData] = React.useState([]);

  const [open, setOpen] = useState(false);

  {/* BookingDetails Variables */}
  const [sendingMethod, setSendingMethod] = React.useState("DROP-OFF");
  const [senderCompany, setSenderCompany] = React.useState("");
  const [showBookingDetails, setShowBookingDetails] = useState(false);
  const [confirmBooking, setConfirmBooking] = React.useState(false);
  const [currentStage, setStage] = React.useState(2);
  const [deliveryMethod, setDeliveryMethod] = React.useState("HOME DELIVERY");
  const [isABMOpen, setIsABMOpen] = React.useState(false);
  const [purchaseOrder, setpurchaseOrder] = React.useState(false);
  const [selectedPayment, setSelectedPayment] = useState("");
  const [showPaymentDetails, setShowPaymentDetails] = useState(true);
  const [senderSelectedAddress, setSenderSelectedAddress] = React.useState(null);

  {
    /* == Sender Details States == */
  }
  const [senderFName, setSenderFName] = React.useState("");
  const [senderFNameErr, setSenderFNameErr] = React.useState("");
  const [senderLName, setSenderLName] = React.useState("");
  const [senderLNameErr, setSenderLNameErr] = React.useState("");
  const [senderNum, setSenderNum] = React.useState("");
  const [senderNumErr, setSenderNumErr] = React.useState("");

  const [senderFlr, setSenderUnit] = React.useState("");
  const [senderFlrError, setSenderUnitErr] = React.useState("");

  {
    /* == Receiver Details States == */
  }

  const [receiverFName, setReceiverFName] = React.useState("");
  const [receiverFNameErr, setReceiverFNameErr] = React.useState("");
  const [receiverLName, setReceiverLName] = React.useState("");
  const [receiverLNameErr, setReceiverLNameErr] = React.useState("");
  const [receiverNum, setReceiverNum] = React.useState("");
  const [receiverNumErr, setReceiverNumErr] = React.useState("");
  const [receiverName, setReceiverName] = React.useState("");
  const [receiverNameErr, setReceiverNameErr] = React.useState("");
  const [receiverUnit, setReceiverUnit] = React.useState("");
  const [receiverUnitErr, setReceiverUnitErr] = React.useState("");
  const [receiverStreet, setReceiverStreet] = React.useState("");
  const [receiverStreetErr, setReceiverStreetErr] = React.useState("");
  
  const [receiverLandmark, setReceiverLandmark] = React.useState("");

  const [senderProvinceData, setSenderProvinceData] = React.useState([]);
  const [senderProvince, setSenderProvince] = React.useState({
    value: 0,
    label: "Province",
  });
  const [senderProvinceErr, setSenderProvinceErr] = React.useState("");
  
  const [receiverProvinceErr, setReceiverProvinceErr] = React.useState("");
  const [receiverProvinceData, setReceiverProvinceData] = React.useState([]);
  const [receiverProvince, setReceiverProvince] = React.useState({
    value: 0,
    label: "Province",
  });

  const [receiverCityErr, setReceiverCityErr] = React.useState("");
  const [receiverCityData, setReceiverCityData] = React.useState([]);
  const [receiverCity, setReceiverCity] = React.useState({
    value: 0,
    label: "City/Municipality",
  });

  const [receiverBrgyErr, setReceiverBrgyErr] = React.useState("");
  const [receiverBrgyData, setReceiverBrgyData] = React.useState([]);
  const [receiverBrgy, setReceiverBrgy] = React.useState({
    value: 0,
    label: "Barangay",
  });

  const [receiverBrgyFilled, setReceiverBrgyFilled] = React.useState(false);
  const [senderBrgyData, setSenderBrgyData] = React.useState([]);
  const [senderBrgy, setSenderBrgy] = React.useState({
    value: 0,
    label: "Barangay",
  });
  const [receiverProvinceFilled, setReceiverProvinceFilled] =
      React.useState(false);
  const [receiverCityFilled, setReceiverCityFilled] = React.useState(false);
  const [senderBrgyErr, setSenderBrgyErr] = React.useState("");
  const [senderBrgyFilled, setSenderBrgyFilled] = React.useState(false);
  const [senderCityData, setSenderCityData] = React.useState([]);

  const [senderProvinceFilled, setSenderProvinceFilled] = React.useState(false);
  const [senderCityFilled, setSenderCityFilled] = React.useState(false);

  const [cartItems, setCartItems] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [openOrderModal, setOpenOrderModal] = useState(false);

  const [isSaveForLater, setIsSaveForLater] = React.useState(false);

  // Parameter
  const [pkgServiceFee, setPkgServiceFee] = React.useState(null);

  const [editValidated, setEditValidated] = React.useState(false);

  const [bookingNo, setBookingNo] = React.useState("");

  const [customerDetails, setCustomerDetails] = React.useState(null);

  const [showLeaveModal, setShowLeaveModal] = useState(false);

  const [showConfirmLeave, setShowConfirmLeave] = React.useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(showConfirmLeave);

  const [showPromptTab, setShowPromptTab] = React.useState(false);

  const [selectedIndex, setSelectedIndex] = React.useState(-1);

  const [toSelectedIndex, setToSelectedIndex] = React.useState(0);

  const [showProofUpload, setShowProofUpload] = useState(false);

  const [proofFile, setProofFile] = useState(null);
  const [proofFileBase64, setProofFileBase64] = useState(null);

  const [cartEditMode, setCartEditMode] = React.useState(false);
  const [editTargetKey, setEditTargetKey] = React.useState(null);

  const [imageBase64, setImageBase64] = useState("");
  const [base64Image, setBase64Image] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const [bookingNoSummary, setBookingNoSummary] = useState("");
  const [trackingNoSummary, setTrackingNoSummary] = useState("");

  const [isValidImage, setIsValidImage] = useState(false);

  const tabs = [
    {
      id: "sendTipidBookNow",
      name: "SendTipid",
      tabIndex: 0,
    },
    {
      id: "sendTipidReports",
      name: "SendTipid Reports",
      tabIndex: 1,
    },
  ];

  React.useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;

    const _bulkSessionId =
      blkSessionId && blkSessionId !== ""
        ? blkSessionId
        : Math.floor(1000000000 + Math.random() * 9000000000);
    setBulkSessionId(_bulkSessionId);

    var _shipperAcct = cookies.get("shipperAcct", { path: "/" });
    var _shipperAcctSplit = _shipperAcct ? _shipperAcct.split("|") : [];
    var _shipperAcctName = _shipperAcctSplit[0]
      ? _shipperAcctSplit[0].toString().trim()
      : "";
    var _shipperAcctNo = _shipperAcctSplit[1]
      ? _shipperAcctSplit[1].toString().trim()
      : "";

    setShipperAcctName(_shipperAcctName);
    setShipperAcctNo(_shipperAcctNo);

    getProvinces(deliveryMethod);

    GetCorpPortalSendTipidProducts("Booking");

    getCustomerDetails(_shipperAcctNo);

    if (data) {
      if (data.editItem) {
        setEditStates(data.editItem, _shipperAcctName, _shipperAcctNo);
        console.log("Hello");
      } else {
        setSenderCompany(_shipperAcctName);
        setBulkSessionId(data.bulkSessionId || "");
        getProvinces(deliveryMethod);
        console.log("World");
      }
    }

  }, []);

  React.useEffect(() => {
    if (
      !editValidated &&
      data &&
      data.editItem &&
      receiverProvinceFilled &&
      receiverCityFilled &&
      receiverBrgyFilled &&
      !loading
    ) {
      validateReceiverDetails();
      setEditValidated(true);
    }
    }, [
      editValidated,
      receiverProvinceFilled,
      receiverCityFilled,
      receiverBrgyFilled,
      loading,
  ]);

  const validateReceiverDetails = () => {
    let validDetails = true;

    setReceiverFNameErr(receiverFName === "" ? "First Name is required." : "");
    setReceiverLNameErr(receiverLName === "" ? "Last Name is required." : "");
  
    setReceiverNumErr(
      receiverNum === ""
        ? "Contact Number is required."
        : !isMobileNumber(receiverNum)
        ? "Enter a valid mobile number."
        : ""
    );
    setReceiverUnitErr(
      deliveryMethod === "HOME DELIVERY" && receiverUnit === ""
        ? "Unit is required."
        : ""
    );

    setReceiverProvinceErr(
      receiverProvince.value === 0 ? "Please select a Province." : ""
    );
    setReceiverCityErr(receiverCity.value === 0 ? "Please select a City." : "");
    setReceiverBrgyErr(
      receiverBrgy.value === 0
        ? deliveryMethod === "HOME DELIVERY"
          ? "Please select a Barangay."
          : "Please select a Branch."
          : ""
    );
  
    validDetails =
    receiverFName !== "" &&
    receiverLName !== "" &&
    receiverNum !== "" &&
    isMobileNumber(receiverNum) &&
      ((deliveryMethod === "HOME DELIVERY" && receiverUnit !== "") ||
        deliveryMethod !== "HOME DELIVERY") &&
        receiverProvince.value !== 0 &&
        receiverCity.value !== 0 &&
        receiverBrgy.value !== 0;

    return validDetails;
  };

  const setEditStates = (item, shipperAcctName, shipperAcctNo) => {
    const _receiverAddress = item.ConsigneeStBldg.split(",");
    const _receiverUnit = _receiverAddress[0] ? _receiverAddress[0].trim() : "";
    const _receiverStreet = _receiverAddress[1]
      ? _receiverAddress[1].trim()
      : "";
    const _receiverLandmark = _receiverAddress[2]
      ? _receiverAddress[2].trim()
      : "";
    
    const attachmentNameThree = item.AttachmentNameThree.split("|");
    const _useCODCOP = attachmentNameThree[1]
      ? Number(attachmentNameThree[1].trim())
      : 0;
    
    setBulkSessionId(item.BulkSessionId);
    
    setShipperAcctName(item.Shipper);
    setShipperAcctNo(
      item.ShipperAccountNo.trim() === ""
        ? shipperAcctNo
        : item.ShipperAccountNo.trim()
      );

    setDeliveryMethod(item.ReferenceNoFour);
    setReceiverName(item.Consignee);
    setReceiverNum(item.ConsigneeMobileNumber);
    setReceiverUnit(_receiverUnit);
    setReceiverStreet(_receiverStreet);
    setReceiverLandmark(_receiverLandmark);
    
    getProvinces(deliveryMethod);
  };

  const GetCorpPortalSendTipidProducts = async (productFor) => {
    setPkgData([]);
    setLoading(true);

    const reqData = {
      productFor: productFor,
    };

    try {
      const response = await axiosCAPApiPrivate.post(
        "/api/GetCorpPortalSendTipidProducts",
        reqData
      );

      const resData = response.data;

      if (resData.Code === "200") {
        setPkgData(resData.Data);

        setLoading(false);

      } else {
        setToastKind("info");
        setToastTitle("Information");
        setToastDesc(resData.Message);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        setTimeout(() => {
          setToastOpen(true);
        }, 1500);
        setTimeout(() => {
          setToastOpen(false);
        }, 5000);
      }

    } catch (error) {
      setToastKind("error");
      setToastTitle("API Fetch Failed!");
      setToastDesc(error.message);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setTimeout(() => {
        setToastOpen(true);
      }, 1500);
      setTimeout(() => {
        setToastOpen(false);
      }, 5000);
    }
  };
  
  const onSaveLater = () => {
    setLoading(true);
    if (currentStage > 2) {
      setTimeout(() => {
        setShowConfirmLeave(false);
        setShowBookingDetails(false);
      }, 2000);
      setTimeout(() => {
        setLoading(false);
        setToastOpen1(false);
        setIsSaveForLater(true);
      }, 3000);
    }
  };

  React.useEffect(() => {
    if (isSaveForLater) {
      onSaveLater(pkgServiceFee);
    }
  }, [isSaveForLater]);

  const handleOrderNow = () => {
    setShowBookingDetails(true);
    setOpen(false);
  };

  const onDeliveryMethodChange = (deliveryMethod) => {
    setDeliveryMethod(deliveryMethod);

    setSenderProvinceData([]);
    setSenderProvince({
      value: 0,
      label: "Province",
    });
  };

  const getProvinces = async (sendDelMethod) => {
    setLoading(true);
  
    let url = ";";
    if (sendDelMethod === "DROP-OFF") {
      url = "/RequestRefProvince?token=TEJDdmlzdHJhcGhfdXNlclYxc3RSQHBoMjAxNw==";
    } else if (sendDelMethod === "HOME DELIVERY") {
      url = "/RequestRefProvince?token=TEJDdmlzdHJhcGhfdXNlclYxc3RSQHBoMjAxNw==";
    } else {
      url = "/RequestRefProvinceWithActiveBranch?token=TEJDdmlzdHJhcGhfdXNlclYxc3RSQHBoMjAxNw==";
    }
  
    try {
      const response = await axiosCommonRefApi.get(url);
      const resData = response.data;
  
      if (resData.Code === "200") {
        if (sendDelMethod === "DROP-OFF") {
          setSenderProvinceData(resData.Province);
        } else {
          setReceiverProvinceData(resData.Province);
        }
  
        setLoading(false);
      } else {
        if (sendDelMethod === "DROP-OFF") {
          setSenderProvinceData([]);
          if (data && data.editItem) {
            setSenderProvinceFilled(true);
            setSenderCityFilled(true);
            setSenderBrgyFilled(true);
            }
          } else {
            setReceiverProvinceData([]);
            if (data && data.editItem) {
              setReceiverProvinceFilled(true);
              setReceiverCityFilled(true);
              setReceiverBrgyFilled(true);
            }
          }
  
          setToastKind2("info");
          setToastTitle2("Invormation");
          setToastDesc2(resData.Message);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          setTimeout(() => {
            setToastOpen2(true);
          }, 1500);
          setTimeout(() => {
            setToastOpen2(false);
          }, 5000);
        }
    } catch (error) {
        setToastKind2("error");
        setToastTitle2("API Fetch Failed!");
        setToastDesc2(error.message);
  
        if (sendDelMethod === "DROP-OFF") {
          setSenderProvinceData([]);
          if (data && data.editItem) {
            setSenderProvinceFilled(true);
            setSenderCityFilled(true);
            setSenderBrgyFilled(true);
          }
        } else {
          setReceiverProvinceData([]);
          if (data && data.editItem) {
            setReceiverProvinceFilled(true);
            setReceiverCityFilled(true);
            setReceiverBrgyFilled(true);
          }
        }
  
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        setTimeout(() => {
          setToastOpen2(true);
        }, 1500);
        setTimeout(() => {
          setToastOpen2(false);
        }, 5000);
      }
  };

  const getCities = async (sendDelMethod, provinceId) => {
    setLoading(true); 

    let url = `/RequestRefCities?token=TEJDdmlzdHJhcGhfdXNlclYxc3RSQHBoMjAxNw==&provinceid=${provinceId}`;

    try {
      const response = await axiosCommonRefApi.get(url);
      const resData = response.data;

      if (resData.Code === "200") {
        if (sendDelMethod === "DROP-OFF") {
          setSenderCityData(resData.City);
        } else {
          setReceiverCityData(resData.City);
        }
      } else if (resData.Code === "204") {
        setReceiverCityData([]);
        setToastKind2("info");
        setToastTitle2("Information");
        setToastDesc2("No serviceable city for this selected province.");
        setToastOpen2(true);
        setTimeout(() => setToastOpen2(false), 5000);
      } else {
        setReceiverCityData([]);
        setToastKind2("info");
        setToastTitle2("Information");
        setToastDesc2(resData.Message);
        setToastOpen2(true);
        setTimeout(() => setToastOpen2(false), 5000);
      }
    } catch (error) {
      setToastKind2("error");
      setToastTitle2("API Fetch Failed!");
      setToastDesc2(error.message);
      setToastOpen2(true);
      setTimeout(() => setToastOpen2(false), 5000);
    } finally {
      setLoading(false);
    }
  };

  const getBarangays = async (sendDelMethod, provinceId, cityId) => {
    setLoading(true);

    let url = "";
    if (sendDelMethod === "DROP-OFF") {
      url = `/RequestRefBarangayPSGC?token=TEJDdmlzdHJhcGhfdXNlclYxc3RSQHBoMjAxNw==&cityid=${cityId}`;
    } else if (sendDelMethod === "HOME DELIVERY") {
      url = `/RequestRefBarangayPSGC?token=TEJDdmlzdHJhcGhfdXNlclYxc3RSQHBoMjAxNw==&cityid=${cityId}`;
    } else {
      url = `/RequestRefBranch?token=TEJDdmlzdHJhcGhfdXNlclYxc3RSQHBoMjAxNw==&provinceid=${provinceId}&cityid=${cityId}`;
    }

    try {
      const response = await axiosCommonRefApi.get(url);
      const resData = response.data;

      if (resData.Code === "200") {
        if (sendDelMethod === "DROP-OFF") {
          setSenderBrgyData(resData.Barangay);
        } else {
          setReceiverBrgyData(resData.Barangay || resData.Branch);
        }
      } else if (resData.Code === "204") {
        if (sendDelMethod === "DROP-OFF") {
          setSenderBrgyData([]);
          if (data?.editItem) {
            setSenderBrgyFilled(true);
          }
        } else {
          setReceiverBrgyData([]);
          if (data?.editItem) {
            setReceiverBrgyFilled(true);
          }
        }

        setToastKind2("info");
        setToastTitle2("Information");
        setToastDesc2(
          sendDelMethod === "HOME DELIVERY"
            ? "No serviceable barangay for this selected city."
            : "No active branch for this selected city."
        );

        setToastOpen2(true);
        setTimeout(() => setToastOpen2(false), 5000);
      }
    } catch (error) {
      setToastKind2("error");
      setToastTitle2("API Fetch Failed!");
      setToastDesc2(error.message);
      setToastOpen2(true);
      setTimeout(() => setToastOpen2(false), 5000);
    } finally {
      setLoading(false);
    }
  };

  const getCustomerDetails = async (customerAccountNo) => {
    setCustomerDetails(null);
    setLoading(true);

    try {
      const response = await axiosCAPApiPrivate.get(
        "/api/GetCustomerDetails/" + customerAccountNo
      );
      const resData = response.data;

      if (resData.Code === "200") {
        setCustomerDetails(resData.Data);
        console.log(resData.Data);
        setLoading(false);
      } else {
        setToastKind2("info"); 
        setToastTitle2("Invormation");
        setToastDesc2(resData.Message);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        setTimeout(() => {
          setToastOpen2(true);
        }, 1500);
        setTimeout(() => {
          setToastOpen2(false);
        }, 5000);
      }
    } catch (error) {
      setToastKind2("error");
      setToastTitle2("API Fetch Failed!");
      setToastDesc2(error.message);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setTimeout(() => {
        setToastOpen2(true);
      }, 1500);
      setTimeout(() => {
        setToastOpen2(false);
      }, 5000);
    }
  };

  const onReceiverProvinceChange = (deliveryMethod, receiverProvince) => {
    setReceiverProvince(receiverProvince);

    if (receiverProvince.value !== 0) {
      setReceiverCityData([]);
      setReceiverCity({
        value: 0,
        label: "City/Municipality",
      });
      setReceiverBrgyData([]);
      setReceiverBrgy({
        value: 0,
        label: "Barangay",
      });

      getCities(deliveryMethod, receiverProvince.value);
    }

    setReceiverProvinceErr(
      receiverProvince.value === 0 ? "Please select a Province." : ""
    );
  }

  const onReceiverCityChange = (
    deliveryMethod,
    receiverProvince,
    receiverCity
  ) => {
    setReceiverCity(receiverCity);

    if (receiverCity.value !== 0) {
      setReceiverBrgyData([]);
      setReceiverBrgy({
        value: 0,
        label: deliveryMethod === "HOME DELIVERY" ? "Barangay" : "Branch",
      });

      getBarangays(deliveryMethod, receiverProvince.value, receiverCity.value);
    }

    setReceiverCityErr(receiverCity.value === 0 ? "Please select a City." : "");
  };

  const onReceiverBrgyChange = (receiverBrgy) => {
    setReceiverBrgy(receiverBrgy);
    setReceiverBrgyErr(
      receiverBrgy.value === 0
        ? deliveryMethod === "HOME DELIVERY"
          ? "Please select a Barangay."
          : "Please select a Branch."
        : ""
    );
  };

  React.useEffect(() => {
    if (
      data?.editItem &&
      !receiverProvinceFilled &&
      receiverProvinceData.length > 0
    ) {
      setReceiverProvince({
        value: data.editItem.ConsigneeProvinceId || 0,
        label: data.editItem.ConsigneeProvince || "Province",
      });

      if (data.editItem.ConsigneeProvinceId) {
        getCities(deliveryMethod, data.editItem.ConsigneeProvinceId);
      } else {
        setReceiverCityFilled(true);
        setReceiverBrgyFilled(true);
      }
    } else {
      console.log("Skipping province block. Data:", data);
    }
  }, [data, receiverProvinceFilled, receiverProvinceData]);

  React.useEffect(() => {
    if (
      data &&
      data.editItem &&
      !receiverCityFilled &&
      receiverCityData.length > 0
    ) {
      const editItemConsigneeCity = receiverCityData.find(
        (city) =>
          Number(city.CityId || city.CityID) ===
          Number(data.editItem.ConsigneeCityMunicipalityId)
      );

      setReceiverCity({
        value:
          data.editItem.ConsigneeCityMunicipality !== "" &&
          editItemConsigneeCity
            ? data.editItem.ConsigneeCityMunicipalityId
            : 0,
        label:
          data.editItem.ConsigneeCityMunicipality !== "" &&
          editItemConsigneeCity
            ? data.editItem.ConsigneeCityMunicipality
            : "City/Municipality",
      });

      if (
        data.editItem.ConsigneeCityMunicipality !== "" &&
        editItemConsigneeCity
      ) {
        getBarangays(
          deliveryMethod,
          data.editItem.ConsigneeProvinceId,
          data.editItem.ConsigneeCityMunicipalityId
        );
      } else {
        setReceiverBrgyFilled(true);
      }

      setReceiverCityFilled(true);
    } else {
      console.log("Hello City Else");
    }
  }, [receiverCityFilled, receiverCityData]);

  React.useEffect(() => {
      if (
        data &&
        data.editItem &&
        !receiverBrgyFilled &&
        receiverBrgyData.length > 0
      ) {
        const editItemConsigneeBrgy = receiverBrgyData.find(
          (brgy) =>
            Number(brgy.BarangayId || brgy.BarangayID || brgy.branchid) ===
            Number(data.editItem.ConsigneeBrgyId)
        );
        setReceiverBrgy({
          value:
            data.editItem.ConsigneeBrgy !== "" &&
            Number(data.editItem.ConsigneeBrgyId) !== 0 &&
            editItemConsigneeBrgy
              ? data.editItem.ConsigneeBrgyId
              : 0,
          label:
            data.editItem.ConsigneeBrgy !== "" &&
            Number(data.editItem.ConsigneeBrgyId) !== 0 &&
            editItemConsigneeBrgy
              ? data.editItem.ConsigneeBrgy
              : deliveryMethod === "HOME DELIVERY"
              ? "Barangay"
              : "Branch",
        });
  
        setReceiverBrgyFilled(true);
      } else {
        console.log("Hello Brgy");
      }
  }, [receiverBrgyFilled, receiverBrgyData]);
  
  const onSelectAddress = (item) => {
    // Normalize keys para consistent sa code
    const normalizedItem = {
      ...item,
      provinceId: item.provId,
      provinceName: item.provName,
      cityId: item.cityId,
      cityName: item.cityName,
      barangayId: item.brgyId,
      barangayName: item.brgyName,
    };

    console.log("Normalized Address:", normalizedItem);
    setSenderSelectedAddress(normalizedItem);

    setReceiverBrgy({
      value: normalizedItem.barangayId,
      label: normalizedItem.barangayName,
    });
  };

  React.useEffect(() => {
    if (senderSelectedAddress !== null) {
      const fullName = senderSelectedAddress.contactPerson || "";
      const nameParts = fullName.trim().split(" ").filter(Boolean);

      const firstName = nameParts[0];
      const lastName = nameParts.slice(1).join(" ") || "";

      // Set input values
      onReceiverFNameChange(firstName);
      onReceiverLNameChange(lastName);
      onReceiverNumChange(senderSelectedAddress.mobileNo);
      onReceiverUnitChange(senderSelectedAddress.pickupAddress.replaceAll(",", ""));

      // Reset fills
      setReceiverProvinceFilled(false);
      setReceiverCityFilled(false);
      setReceiverBrgyFilled(false);

      // Get provinces list (usually initial load)
      getProvinces(deliveryMethod);

      // Set Province
      if (senderSelectedAddress.provinceId && senderSelectedAddress.provinceName) {
        const provinceOption = {
          value: senderSelectedAddress.provinceId,
          label: senderSelectedAddress.provinceName,
        };
        setReceiverProvince(provinceOption);

        // Get cities after setting province
        getCities(senderSelectedAddress.provinceId);
      }

      // Set City
      if (senderSelectedAddress.cityId && senderSelectedAddress.cityName) {
        const cityOption = {
          value: senderSelectedAddress.cityId,
          label: senderSelectedAddress.cityName,
        };
        setReceiverCity(cityOption);

        // Get barangays after setting city
        getBarangays(
          deliveryMethod,
          senderSelectedAddress.provinceId,
          senderSelectedAddress.cityId
        );
      }

      // Set Barangay (wait for barangay list to load before showing in dropdown)
      if (senderSelectedAddress.barangayId && senderSelectedAddress.barangayName) {
        const brgyOption = {
          value: senderSelectedAddress.barangayId,
          label: senderSelectedAddress.barangayName,
        };
        setReceiverBrgy(brgyOption);
      }

      console.log("Sender Address set", senderSelectedAddress);
    }
  }, [senderSelectedAddress]);

  React.useEffect(() => {
    if (
      receiverProvinceData.length > 0 &&
      senderSelectedAddress?.provinceId &&
      senderSelectedAddress?.provinceName
    ) {
      const match = receiverProvinceData.find(
        (p) => p.value === senderSelectedAddress.provinceId
      );

      if (match) {
        setReceiverProvince(match);
      } else {
        setReceiverProvince({
          value: senderSelectedAddress.provinceId,
          label: senderSelectedAddress.provinceName,
        });
      }

      getCities(senderSelectedAddress.provinceId);
    }
  }, [receiverProvinceData]);

  React.useEffect(() => {
    if (
      senderSelectedAddress &&
      senderSelectedAddress.provId &&
      senderSelectedAddress.provName &&
      senderProvinceData.length > 0
    ) {
      const matchedProvince = receiverProvinceData.find(
        (prov) => prov.value === senderSelectedAddress.provId
      );

      if (matchedProvince) {
        setSenderProvince(matchedProvince);
      } else {
        setSenderProvince({
          value: senderSelectedAddress.provId,
          label: senderSelectedAddress.provName,
        });
      }

      getCities(senderSelectedAddress.provId);
    }
  }, [senderSelectedAddress, receiverProvinceData]);

  React.useEffect(() => {
    getProvinces("DROP-OFF");
  }, []);

  React.useEffect(() => {
      if (
        !editValidated &&
        data &&
        data.editItem &&
        senderProvinceFilled &&
        senderCityFilled &&
        senderBrgyFilled &&
        receiverProvinceFilled &&
        receiverCityFilled &&
        receiverBrgyFilled &&
        !loading
      ) {
        validateReceiverDetails();
        setEditValidated(true);
      }
    }, [
      editValidated,
      senderProvinceFilled,
      senderCityFilled,
      senderBrgyFilled,
      receiverProvinceFilled,
      receiverCityFilled,
      receiverBrgyFilled,
      loading,
    ]);

  const onChangeStage = (stage, type) => {

    let validReceiver = true;
    if (type === "next" && stage === 2) {
      validReceiver = validateReceiverDetails();
    }

    if (validReceiver) {
      if (type === "next" && stage === 3) {
        setpurchaseOrder(true);
      } else if (type === "next") {
        setStage(stage + 1);
        setpurchaseOrder(false);
      } else if (type === "prev") {
        if (stage === 3 && purchaseOrder) {
          setpurchaseOrder(false);
        } else {
          setStage(stage - 1);
        }
      }
    }
  };

  const onSaveOrder = async () => {
    setLoading(true);

    const date = new Date();
    const formatted = date.toLocaleString("en-PH", { timeZone: "Asia/Manila" });

    const suppliesList = [];

    cartItems.forEach((item) => {
      const fullData = pkgData.find((pkg) => pkg.prodId === item.prodId);

      if (!fullData) {
        console.warn("⚠️ No matching pkgData for prodId:", item.prodId);
        return;
      }

      const productLine = fullData?.productLineId ?? 0;

      const receiverAddress =
        deliveryMethod === "HOME DELIVERY"
          ? `${receiverUnit?.trim().replaceAll(",", "")}, ${receiverStreet?.trim().replaceAll(",", "")}, ${receiverLandmark?.trim().replaceAll(",", "")}`
          : "";

      const areaTypes = [
        { area: "NCR", qty: item.quantity?.ncr, price: item.price?.ncr },
        { area: "Outside NCR", qty: item.quantity?.outsideNCR, price: item.price?.outsideNCR }
      ];

      areaTypes.forEach(({ area, qty, price }) => {
        if (!qty || qty <= 0) return;

        const areaKey = area.toLowerCase().replace(" ", "");
        const serviceFees = item.pkgServiceFee?.[areaKey] || {};
        const totalAmount = qty * price;

        const supplies = {
          BookingNo: data && data.editItem ? data.editItem.BookingNo : "",
          TrackingNo: data && data.editItem ? data.editItem.TrackingNo : "",
          ShipmentMode: 1,
          TransactionDate: formatted,
          ShipperAccountNo: shipperAcctNo,
          ShipperFirstName: receiverFName,
          ShipperLastName: receiverLName,
          Shipper: "Credit and Collection",
          ShipperStBldg: receiverAddress,
          ShipperBrgy: Number(receiverBrgy.value),
          ShipperCityMunicipality: Number(receiverCity.value),
          ShipperProvince: Number(receiverProvince.value),
          ShipperContactNumber: receiverNum,
          ShipperSendSMS: 1,
          ShipperMobileNumber: receiverNum,
          ShipperEmail: customerDetails?.emailAddress || "",
          ProductLine: productLine,
          ServiceMode: 8,
          CODAmount: Number(totalAmount),
          ConsigneeFirstName: receiverFName,
          ConsigneeLastName: receiverLName,
          Consignee: "Credit and Collection",
          ConsigneeStBldg: receiverAddress,
          ConsigneeBrgy: receiverBrgy.value,
          ConsigneeCityMunicipality: receiverCity.value,
          ConsigneeProvince: receiverProvince.value,
          ConsigneeContactNumber: receiverNum,
          ConsigneeMobileNumber: receiverNum,
          ConsigneeSendSMS: 1,
          ReferenceNoOne: "",
          ReferenceNoTwo: "ACCEPTED AT",
          ReferenceNoThree: "",
          Description: "",
          AttachmentNameOne: "CASH",
          ReferenceNoFour: deliveryMethod,
          Client: "CorpTNT",
          DestinationCode: "",
          Quantity: qty,
          PKG: item.prodId,
          ACTWTKgs: 0,
          LengthCM: 0,
          WidthCM: 0,
          HeightCM: 0,
          VolWTcbm: 0,
          CBM: 0,
          ChargeableWT: 0,
          DeclaredValue: 0,
          Commodity: 0,
          ForCrating: 0,
          Paymentmode: 1,
          ValuationFee: 0,
          ShippingFee: 0,
          EstimatedFreightRate: 0,
          PickupDate: moment(date).format("YYYY-MM-DD hh:mm A"),
          SpecialInstructions: "",
          LastStatusLocation: "PENDING BOOKING",
          ContactPerson: receiverName,
          LastDatePosted: date,
          BulkSessionId: bulkSessionId,
          ShipperZipCode: 0,
          ConsigneeZipCode: 0,
          RefBookingNo: "",
          PayCollectServc: 0,
          BoxFee: 0,
          SoShopTier: "",
          SaveForLater: isSaveForLater,
        }
        suppliesList.push(supplies);
      });
    });

    console.log("Final Supplies List:", suppliesList);

    if (suppliesList.length === 0) {
      setToastKind("error");
      setToastTitle("No Orders Found");
      setToastDesc("Please check your cart and quantities.");
      setLoading(false);
      setToastOpen(true);
      setTimeout(() => setToastOpen(false), 5000);
      return;
    }

    try {
      const response = await axiosCAPApiPrivate.post(
        "/api/SendTipidCorpDomesticStaging",
        suppliesList
      );

      const resData = response.data;
      // const bookingNo = resData[0].BookingNo;
      // // setBookingNo(bookingNo);
      // console.log("BookingNo: ", bookingNo);
      console.log(resData.Data);

      clearStates();

      if (resData.Code === "200") {
        console.log("Data: ", resData.Data);
        const bulkSessionId = resData?.Data?.[0]?.BulkSessionId;
        getBookingSummary(bulkSessionId);
        getBookingNo(bulkSessionId);
        setConfirmBooking(true);
        // sendEmailConfirmation(bulkSessionId);
      } else {
        console.warn("Booking Failed:", resData);
        setToastKind("error");
        setToastTitle("Booking Failed");
        setToastDesc(resData.Message || "Something went wrong.");
        setToastOpen(true); // error toast
      }
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
      setToastKind("error");
      setToastTitle("API Fetch Failed!");
      setToastDesc(error.message);
    } finally {
      setTimeout(() => setLoading(false), 1000);
      setTimeout(() => setToastOpen(false), 1500);
      setTimeout(() => setToastOpen(false), 5500);
      setTimeout(() => setToastOpen(false), 5000);
    }
  };

  const getBookingNo = async (bulkSessionId) => {
    const reqData = {
      bulkSessionId: bulkSessionId
    };

    console.log(reqData);

    try {
      const response = await axiosCAPApiPrivate.post(
        "/api/SendTipidBookingNoCheck",
        reqData
      );

      const resData = response.data;
      const bookingNo = resData.Data[0]?.BookingNo;
      console.log("Booking No: ", bookingNo);
      setBookingNo(bookingNo);
      sendEmailConfirmation(bulkSessionId, bookingNo);
    } catch (error) {
      setToastKind2("error");
      setToastTitle2("API Fetch Failed!");
      setToastDesc2(error.message);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setTimeout(() => {
        setToastOpen2(true);
      }, 1500);
      setTimeout(() => {
        setToastOpen2(false);
      }, 5000);
    }
  };

  const onReceiverNameChange = (value) => {
    setReceiverName(value);
    setReceiverNameErr(value === "" ? "Contact Name is required." : "");
  };

  const onReceiverFNameChange = (value) => {
    setReceiverFName(value);
    setReceiverFNameErr(value === "" ? "First Name is required." : "");
  };

  const onReceiverLNameChange = (value) => {
    setReceiverLName(value);
    setReceiverLNameErr(value === "" ? "Last Name is required." : "");
  };

  const onSenderNumChange = (value) => {
    if (isNumber(value)) {
      setSenderNum(value);
      setSenderNumErr(
        value === ""
          ? "Contact Number is required."
          : !isMobileNumber(value)
          ? "Enter a valid mobile number."
          : ""
      );
    }
  };

  const onReceiverNumChange = (value) => {
    if (isNumber(value)) {
      setReceiverNum(value);
      setReceiverNumErr(
        value === ""
          ? "Contact Number is required."
          : !isMobileNumber(value)
          ? "Enter a valid mobile number."
          : ""
      );
    }
  };

  const handleAddToCart = (item) => {
    const matchedProduct = pkgData.find((p) => p.prodId === item.prodId);

    const quantityObj = {
      ncr: item.variation === "NCR" ? item.quantity : 0,
      outsideNCR: item.variation === "Outside NCR" ? item.quantity : 0,
    };

    const priceObj = {
      ncr: matchedProduct?.NCRPrice || 0,
      outsideNCR: matchedProduct?.OutSideNCR || 0,
    };

    const newCartItem = {
      ...item,
      image: item.image || Images.getPackageImageSendTipid(item.prodId),
      quantity: quantityObj,
      price: priceObj,
    };

    if (cartEditMode && editTargetKey) {
      const updatedCart = cartItems.map((ci) => {
        const key = `${ci.prodId}_${ci.variation}`;
        return key === editTargetKey ? newCartItem : ci;
      });

      setCartItems(updatedCart);
    } else {
      const existing = cartItems.find(
        (ci) => ci.prodId === item.prodId && ci.variation === item.variation
      );

      if (existing) {
        const updatedCart = cartItems.map((ci) =>
          ci.prodId === item.prodId && ci.variation === item.variation
            ? {
                ...ci,
                quantity: {
                  ncr: ci.quantity.ncr + quantityObj.ncr,
                  outsideNCR: ci.quantity.outsideNCR + quantityObj.outsideNCR,
                },
              }
            : ci
        );
        setCartItems(updatedCart);
      } else {
        setCartItems([...cartItems, newCartItem]);
      }
    }

    setOpenOrderModal(false);
    setCartEditMode(false);
    setEditTargetKey(null);
    setOpen(true);
  };

  const handleEditClick = (item) => {
    setCartEditMode(true);
    setEditTargetKey(`${item.prodId}_${item.variation}`);
    setSelectedPackage({
      ...item,
      image: Images.getPackageImageSendTipid(item.prodId),
    });
    setShowBookingDetails(false);
  };


  const OrderHandled = (item) => {
    const alreadyInCart = cartItems.some(cart => cart.prodId === item.prodId);
    if (alreadyInCart) return;

    const newItem = {
      ...item,
      quantity: {
        ncr: item.variation === "NCR" ? 1 : 0,
        outsideNCR: item.variation === "Outside NCR" ? 1 : 0,
      },
    };

    setCartItems([...cartItems, newItem]);
    setShowBookingDetails(true);
    setStage(2);
  };

  const onReceiverUnitChange = (value) => {
    setReceiverUnit(value);
    setReceiverUnitErr(
      deliveryMethod === "HOME DELIVERY" && value === ""
        ? "Unit is required."
        : ""
    );
  };

  const sendEmailConfirmationToSender = async (bulkSessionId) => {
    let itemsHtml = "";

    try {

    } catch (error) {
      setToastKind("error");
      setToastTitle("Email Confirmation Failed!");
      setToastDesc(
        "Unable to generate email confirmation. Please contact Corporate Accounts Portal Support Team."
      );
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setTimeout(() => {
        setToastOpen(true);
      }, 1500);
      setTimeout(() => {
        setToastOpen(false);
      }, 5000);
    }
  };

  const sendEmailConfirmation = async (bulkSessionId, bookingNo) => {
    let itemsHtml = "";
    let totalAmount = 0;
    const base64Image = proofFile ? await fileToBase64(proofFile) : null;

    const emailCustomer = customerDetails?.emailAddress;

    // const approveLink = `${config.siteUrl}/approval-confirmation?SessionId=${encodeURIComponent(bulkSessionId)}&Email=${emailCustomer}&BookingNo=${encodeURIComponent(bookingNo)}`;
    // const declinedLink = `${config.siteUrl}/declined-confirmation?SessionId=${encodeURIComponent(bulkSessionId)}&Email=${emailCustomer}&BookingNo=${encodeURIComponent(bookingNo)}`;
    const approveLink = `${window.location.origin}/approval-confirmation?SessionId=${encodeURIComponent(bulkSessionId)}&Email=${emailCustomer}&BookingNo=${encodeURIComponent(bookingNo)}`;
    const declinedLink = `${window.location.origin}/declined-confirmation?SessionId=${encodeURIComponent(bulkSessionId)}&Email=${emailCustomer}&BookingNo=${encodeURIComponent(bookingNo)}`;

    if (Array.isArray(cartItems)) {
      cartItems
        .filter(
          (item) =>
            item &&
            typeof item === "object" &&
            "prodId" in item &&
            item.quantity &&
            item.price &&
            typeof item.price === "object"
        )
        .forEach((item) => {
          const quantity = item.quantity ?? { ncr: 0, outsideNCR: 0 };
          const price = {
            ncr: item.price?.ncr ?? 0,
            outsideNCR: item.price?.outsideNCR ?? 0,
          };

          const ncrTotal = price.ncr * quantity.ncr;
          const outsideTotal = price.outsideNCR * quantity.outsideNCR;

          if (quantity.ncr > 0) {
            itemsHtml += `<p>${item.name} (To NCR) ₱${ncrTotal.toLocaleString()}</p>`;
          }

          if (quantity.outsideNCR > 0) {
            itemsHtml += `<p>${item.name} (Outside NCR) ₱${outsideTotal.toLocaleString()}</p>`;
          }
        });
    }

    // Total Amount
    if (Array.isArray(cartItems)) {
      totalAmount = cartItems
        .filter(
          (item) =>
            item &&
            typeof item === "object" &&
            item.quantity &&
            typeof item.price === "object"
        )
        .reduce((acc, item) => {
          const quantity = {
            ncr: item.quantity?.ncr ?? 0,
            outsideNCR: item.quantity?.outsideNCR ?? 0,
          };

          const price = {
            ncr: item.price?.ncr ?? 0,
            outsideNCR: item.price?.outsideNCR ?? 0,
          };

          return acc + price.ncr * quantity.ncr + price.outsideNCR * quantity.outsideNCR;
        }, 0);
    }

    // const emailBody = `
    //   <p>Hi Credit and Collection Team,</p>
    //   <p>Here is the Send Tipid order by the Account <strong>“${shipperAcctName}”</strong> with Account Number <strong>${shipperAcctNo}</strong></p>
    //   <br />
    //   <p><strong>Receiver Name:</strong> ${receiverFName}, ${receiverLName}</p>
    //   <p><strong>Email Address:</strong> ${customerDetails?.emailAddress}</p>
    //   <p><strong>Booking No.:</strong> ${bookingNo}</p>
    //   ${itemsHtml}
    //   <p><strong>Amount Order:</strong> ₱${totalAmount.toLocaleString()}</p>
    //   <p>Payment Method: <strong>Cash</strong></p>
    //   <img src="data:image/jpeg;base64,${base64Image}" alt="Attached Image" style="max-width: 400px; border: 1px solid #ccc;" />
    //   <br /><br />
    //   <div>
        // <a href="${approveLink}"
        //   style="
        //     display: inline-block;
        //     padding: 10px 20px;
        //     background-color: #28a745;
        //     color: white;
        //     text-decoration: none;
        //     border-radius: 5px;
        //     font-weight: bold;
        //     margin-right: 10px;
        //   ">
        //   Approve
        // </a>
        // <a href="${declinedLink}"
        //   style="
        //     display: inline-block;
        //     padding: 10px 20px;
        //     background-color: #dc3545;
        //     color: white;
        //     text-decoration: none;
        //     border-radius: 5px;
        //     font-weight: bold;
        //   ">
        //   Decline
        // </a>
    //   </div>
    // `;

    const emailBody = `
      <p>Hi Credit and Collection Team,</p>
      <p>Here is the Send Tipid order by the Account <strong>“${shipperAcctName}”</strong> with Account Number <strong>${shipperAcctNo}</strong></p>
      <br />
      <p><strong>Receiver Name:</strong> ${receiverFName}, ${receiverLName}</p>
      <p><strong>Email Address:</strong> ${customerDetails?.emailAddress}</p>
      <p><strong>Booking No.:</strong> ${bookingNo}</p>
      ${itemsHtml}
      <p><strong>Amount Order:</strong> ₱ ${totalAmount.toLocaleString()} </p>
      <p>Payment Method: <strong>Cash</strong></p>
      <br /><br />
      <div>
        <a href="${approveLink}"
          style="
            display: inline-block;
            padding: 10px 20px;
            background-color: #28a745;
            color: white;
            text-decoration: none;
            border-radius: 5px;
            font-weight: bold;
            margin-right: 10px;
          ">
          Approve
        </a>
        <a href="${declinedLink}"
          style="
            display: inline-block;
            padding: 10px 20px;
            background-color: #dc3545;
            color: white;
            text-decoration: none;
            border-radius: 5px;
            font-weight: bold;
          ">
          Decline
        </a>
      </div>
    `;

    try {
      const payload = {
        // fromEmail: "Customercare@lbcexpress.com",
        fromEmail: "noreply-app1@lbcmail.com",
        toEmail: "C&C@lbcexpress.com",
        ccEmail: "Sales_Support@lbcexpress.com,pudsupport@lbcexpress.com,CCMRelManagement@lbcexpress.com",
        subject: "Corporate Account's Portal: ORDER OF SENDTIPID",
        body: emailBody,
        html: true,
        Base64Attachment: base64Image,
        AttachmentName: proofFile?.name || "proof.jpg",
        AttachmentType: proofFile?.type || "image/jpeg"
      };

      const response = await axiosCAPApiPrivate.post("/api/SendEmail", payload, {
        headers: { "Content-Type": "application/json" }
      });

      const data = response.data;
      console.log(data);

    } catch (error) {
      setToastKind("error");
      setToastTitle("Email Confirmation Failed!");
      setToastDesc(
        "Unable to generate email confirmation. Please contact Corporate Accounts Portal Support Team."
      );
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setTimeout(() => {
        setToastOpen(true);
      }, 1500);
      setTimeout(() => {
        setToastOpen(false);
      }, 5000);
    }
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Ito mismo ang gagawa ng base64 string
      reader.onload = () => resolve(reader.result.split(",")[1]); // Kunin lang yung base64 string
      reader.onerror = (error) => reject(error);
    });
  };

  const onConfirmLeaveTab = () => {
    setShowPromptTab(false);
    setShowConfirmLeave(false);
    setSelectedIndex(toSelectedIndex);
    setBulkSessionId("");

    setShowBookingDetails(false);

    setSelectedIndex(toSelectedIndex);
    setBulkSessionId("");

    setCartItems([]);
  };

  const onCancelLeaveTab = () => {
    setShowPromptTab(false);
    setSelectedIndex(selectedIndex);
  };

  // const handleFileChange = async (e) => {
  //   const file = e.target.files[0];
  //   setSelectedFile(file);
  //   const base64 = await fileToBase64(file); // full base64 with "data:image/jpeg;base64,..."
  //   const base64Only = base64.split(',')[1]; // use this for backend
  //   setBase64Image(base64Only);
  // };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setIsValidImage(false);
      return;
    }
    const maxSize = 5 * 1024 * 1024;

    if (file.size > maxSize) {
      setToastKind("error");
      setToastTitle("File Too Large!");
      setToastDesc("Please select an image under 5MB.");
      setTimeout(() => setToastOpen(true), 100); // slight delay to trigger animation
      setTimeout(() => setToastOpen(false), 5100); // auto close after 5s
      return;
    }

    setProofFile(file); // keep the original file
    setIsValidImage(true);

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result.split(",")[1];
      setBase64Image(base64);
    };
    reader.readAsDataURL(file);
  };

  React.useEffect(() => {
    if (showProofUpload) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [showProofUpload]);

  const goToTransaction = () => {
    navigate("/transaction");
  };

  const clearStates = () => {
    setToastOpen1(false);
    setToastOpen2(false);
    setToastKind2("");
    setToastTitle2("");
    setToastDesc2("");
    setToastOpen3(false);
    setIsABMOpen(false);
    setLoading(false);
    setBulkSessionId("");
    setEditValidated(false);
    setShipperAcctName("");
    setShipperAcctNo("");

    setDeliveryMethod("HOME DELIVERY");
    setReceiverName("");
    setReceiverNameErr("");
    setReceiverNum("");
    setReceiverNumErr("");
    setReceiverUnit("");
    setReceiverUnitErr("");
    setReceiverStreet("");
    setReceiverStreetErr("");
    setReceiverProvinceData([]);
    setReceiverProvince({ value: 0, label: "Province" });
    setReceiverProvinceErr("");
    setReceiverCityData([]);
    setReceiverCity({ value: 0, label: "City/Municipality" });
    setReceiverCityErr("");
    setReceiverBrgyData([]);
    setReceiverBrgy({ value: 0, label: "Barangay" });
    setReceiverBrgyErr("");
    setReceiverLandmark("");

    setReceiverProvinceFilled(false);
    setReceiverCityFilled(false);
    setReceiverBrgyFilled(false);
  };

  const getBookingSummary = async (bulkSessionId) => {

    const reqData = {
      BulkSessionId: bulkSessionId,
    };

    try {
      const response = await axiosCAPApiPrivate.post(
        "/api/SendTipidBookingSummary",
        reqData
      );

      const resData = response.data;

      if (resData.Code === "200") {
        setBookingNoSummary(resData.Data);
        console.log("Data", resData.Data);
      }

    } catch (error) {
      setToastKind("error");
      setToastTitle("API Fetch Failed!");
      setToastDesc(error.message);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setTimeout(() => {
        setToastOpen(true);
      }, 1500);
      setTimeout(() => {
        setToastOpen(false);
      }, 5000);
    }
  };

  return (
    <>

      {(loading ||
                      (data &&
                        data.editItem &&
                        (!senderProvinceFilled ||
                          !senderCityFilled ||
                          !senderBrgyFilled ||
                          !receiverProvinceFilled ||
                          !receiverCityFilled ||
                          !receiverBrgyFilled))) && <Loading />}
      {loading && <Loading />}

      {isABMOpen && (
        <AddressBookSendTipidModal
          isOpen={isABMOpen}
          onClose={() => setIsABMOpen(false)}
          data={{ customerAccountNo: shipperAcctNo }}
          onSelect={onSelectAddress}
        />
      )}

      <LBCModal
        description={toastDesc}
        isOpen={isToastOpen}
        onClose={() => setToastOpen(false)}
        title={toastTitle}
        toastKind={toastKind}
      />

      <LBCModalTwoFunc
        id="confirmLeavePage"
        bodyClassName="justify-between bg-white border border-grey-400 w-500px p-5 rounded-lg shadow-lg"
        description="Any changes will be left unsaved."
        isOpen={showPrompt}
        onClose={cancelNavigation}
        title="Are you sure you want to leave this page?"
        buttonTextFirst="Leave page"
        buttonTextSecond="Stay on this page"
        onClickFirst={confirmNavigation}
        onClickSecond={cancelNavigation}
      />
      
      <LBCModalTwoFunc
        id="confirmLeaveTab"
        bodyClassName="justify-between bg-white border border-grey-400 w-500px p-5 rounded-lg shadow-lg"
        description="Any changes will be left unsaved."
        isOpen={showPromptTab}
        onClose={onCancelLeaveTab}
        title={`Are you sure you want to leave ${tabs[selectedIndex]?.name}?`}
        buttonTextFirst="Leave"
        buttonTextSecond="Stay"
        onClickFirst={onConfirmLeaveTab}
        onClickSecond={onCancelLeaveTab}
      />

      <LBCModalTwoFunc
        id="saveForLater"
        description={
          <>
            <p>
              You can go back anytime to finish your booking by clicking
            </p>
            <strong>
              Activity {`>`} Online Bookings {`>`} Draft
            </strong>
            in the menu.
          </>
        }
        isOpen={isToastOpen1}
        onClose={() => setToastOpen1(false)}
        title="Save for later?"
        toastKind="info"
        buttonTextFirst="Cancel"
        buttonTextSecond="Save for later"
        onClickSecond={onSaveLater}
        loading={loading}
      />

      {showBookingDetails ? (
        <>
          {confirmBooking ? (
            <div className="relative w-full h-screen flex items-center px-20 bg-cover bg-center items-start py-3 gap-5" style={{ backgroundImage: `url(${ConfirmImage})` }}>
              <div className="absolute inset-0 bg-black opacity-50 z-10"></div>
              {/* Left-Aligned Content */}
              <div className="relative z-20 text-left max-w-[500px]">
                <h2 className="text-4xl font-bold text-white">Thank You! Your SendTipid order has been successfully booked.</h2>
                <p className="text-white text-lg mt-2"></p>

                {/* Booking Details Card */}
                <div className="mt-6 bg-white p-6 rounded-lg shadow-lg relative z-30 text-black bg-opacity-100 isolate">
                  <h3 className="text-[rgb(208,1,73)] font-bold text-lg text-center">SendTipid - Rider Delivery</h3>
                  <p className="text-center font-semibold text-black">
                    Your bookings: <span className="text-gray-600">{bookingNo}</span>
                  </p>

                  {/* Order Details */}

                  <div className="max-w-[450px] bg-white p-6 rounded-lg shadow-lg relative">
                    {/* <div className="mt-4 max-h-60 overflow-y-auto space-y-4">
                      <div className="mt-4 space-y-3 flex items-start gap-4">
                        <img src={NPouchRegular} alt="N-Pouch Regular" className="w-16 h-16 object-cover" />
                        <div>
                          <p className="font-bold">N-Pouch Regular</p>
                          <p className="text-gray-500 text-sm">11 in x 6.5 in | Max weight: 0.5 kg</p>
                          <p className="text-red-500 font-bold text-sm">1 bundle = 1,400</p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4">
                        <img src={KiloBoxSmall} alt="Kilo Box Small" className="w-16 h-16 object-cover" />
                        <div>
                          <p className="font-bold">Kilo Box Small</p>
                          <p className="text-gray-500 text-sm">12 in x 10 in x 5 in | Max weight: 3 kg</p>
                          <p className="text-red-500 font-bold text-sm">1 bundle = 1,700</p>
                        </div>
                      </div>
                    </div> */}
                    <div className="mt-4 max-h-60 overflow-y-auto space-y-4">
                      {Array.isArray(cartItems) &&
                        cartItems
                          .filter(
                            (item) =>
                              item &&
                              typeof item === "object" &&
                              item.quantity &&
                              typeof item.price === "object"
                          )
                          .map((item, index) => {
                            const quantity = {
                              ncr: item.quantity?.ncr ?? 0,
                              outsideNCR: item.quantity?.outsideNCR ?? 0,
                            };

                            const price = {
                              ncr: item.price?.ncr ?? 0,
                              outsideNCR: item.price?.outsideNCR ?? 0,
                            };

                            const ncrTotal = price.ncr * quantity.ncr;
                            const outsideTotal = price.outsideNCR * quantity.outsideNCR;

                            return (
                              <React.Fragment key={index}>
                                {quantity.ncr > 0 && (
                                  <div className="space-y-3 flex items-start gap-4">
                                    <img
                                      src={item.image}
                                      alt={item.name}
                                      className="w-16 h-16 object-cover"
                                    />
                                    <div>
                                      <p className="font-bold">{item.name} (To NCR)</p>
                                      <p className="text-red-500 font-bold text-sm">
                                        ₱{ncrTotal.toLocaleString()}
                                      </p>
                                    </div>
                                  </div>
                                )}

                                {quantity.outsideNCR > 0 && (
                                  <div className="space-y-3 flex items-start gap-4">
                                    <img
                                      src={item.image}
                                      alt={item.name}
                                      className="w-16 h-16 object-cover"
                                    />
                                    <div>
                                      <p className="font-bold">{item.name} (Outside NCR)</p>
                                      <p className="text-red-500 font-bold text-sm">
                                        ₱{outsideTotal.toLocaleString()}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </React.Fragment>
                            );
                          })}
                    </div>

                  </div>

                  {/* Action Buttons */}
                  <div className="mt-6 flex gap-4">
                    <Button className="w-1/2 bg-red-500 text-white p-3 rounded-lg font-bold" onClick={() => navigate("/")}>
                      Go Back to Home
                    </Button>
                    <Button className="w-1/2 bg-gray-200 text-black p-3 rounded-lg font-bold" onClick={goToTransaction}>
                      Go to Activity
                    </Button>
                  </div>

                  <div className="mt-6 bg-gray-100 p-4 rounded-lg text-sm text-gray-800">
                    <h3 className="font-bold text-lg text-black">Next Steps:</h3>
                    <ul className="list-disc ml-4 text-black">
                      <li>You will receive booking status within 24 hours, if declined, please call/coordinate with your account handler.</li>
                      <li>Our rider will deliver the supplies within 3 to 4 working days after booking date.</li>
                      <li>Ensure the recipient is available to claim the item or it will be redirected.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <FlexRow className="justify-between w-full items-center px-2 py-2 relative">
                <Div className="w-full h-full overflow-y-auto p-4">
                  <FlexRow className="w-full">
                    <Tab.Panels className="w-full mt-[-10px]">
                      <div className="flex justify-start w-full items-start pl-0 py-3 gap-5">
                        <div className="w-1/4 p-5 shadow-md rounded-lg mr-auto ml-[-10px]">
                          {SendTipidBookingStage.map((item, index) => (
                            <StageUISendTipid
                              key={index}
                              label={item.name}
                              count={item.stage}
                              currentIndex={currentStage}
                              onStage={currentStage === item.stage || currentStage > item.stage}
                              isLast={index === SendTipidBookingStage.length - 1}
                            />
                          ))}
                        </div>
                        <div className="flex flex-col w-3/4">
                          <div className="w-full max-w-[1100px] p-6 overflow-y-auto shadow-md rounded-lg min-h-[600px] flex flex-col" style={{ backgroundColor: '#F7F7F7' }}>
                          {/* <div className="w-full max-w-[1100px] bg-gray-300 p-6 overflow-y-auto shadow-md rounded-lg min-h-[600px] flex flex-col"> */}
                            {currentStage === 2 && (
                              <div className="p-6 bg-gray-200 w-full rounded-lg">
                                <h2 className="font-bold">Delivery Method</h2>
                                <div className="send-del-option">
                                  <div className="optn-container">
                                    <input
                                      type="radio"
                                      id="rider-delivery-optn"
                                      name="del-optn"
                                      onChange={() =>
                                        onDeliveryMethodChange("HOME DELIVERY")
                                      }
                                      checked={deliveryMethod === "HOME DELIVERY"}
                                    />
                                    <label
                                      htmlFor="rider-delivery-optn"
                                      style={{
                                        marginRight: "5px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <div className="send-del-optn-body">
                                        <div id="rider-delivery-icon" className="send-del-optn-icon"/>
                                        <div className="send-del-optn-details">
                                          <div className="title">Rider Delivery</div>
                                        </div>
                                      </div>
                                      <span className="checkmark" />
                                    </label>
                                  </div>
                                </div>
                                <Div className="flex flex-col gap-4">
                                  <Div className="flex justify-between items-center">
                                    <h2 className="font-bold">Customer Details</h2>
                                    <ButtonShadow
                                      onClick={() => setIsABMOpen(true)}
                                      className="flex items-center gap-2 px-4 py-2 rounded-md transition-all duration-200"
                                    >
                                      <img className="w-5 h-5" src={Images.addressBook1} alt="Address Book Icon" />
                                      <span className="font-semibold">Address Book</span>
                                    </ButtonShadow>
                                  </Div>
                                  <Div className="grid grid-cols-2 gap-4">
                                    <Div className="flex flex-col">
                                      <Text className="text-secondary-200 text-sm font-semibold" htmlFor="senderFName">
                                        First Name
                                      </Text>
                                      <RawInput
                                        className="border border-gray-400 rounded-md p-2 text-sm w-full mt-2"
                                        name="receiverName"
                                        onChange={onReceiverFNameChange}
                                        placeholder="First Name"
                                        type="text"
                                        value={receiverFName}
                                        autoComplete="off"
                                        validation={receiverFNameErr}
                                        disabled
                                      />
                                    </Div>
                                    <Div className="flex flex-col">
                                      <Text className="text-secondary-200 text-sm font-semibold" htmlFor="senderLName">
                                        Last Name
                                      </Text>
                                      <RawInput
                                        className="border border-gray-400 rounded-md p-2 text-sm w-full mt-2"
                                        name="receiverLName"
                                        onChange={onReceiverLNameChange}
                                        placeholder="Last Name"
                                        type="text"
                                        value={receiverLName}
                                        autoComplete="off"
                                        validation={receiverLNameErr}
                                        disabled
                                      />
                                    </Div>
                                    <Div className="flex flex-col">
                                      <Text className="text-secondary-200 text-sm font-semibold" htmlFor="senderNum">
                                        Mobile Number
                                      </Text>
                                      <Div className="relative w-full">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 text-secondary-200 text-sm">
                                          +63
                                        </div>
                                        <RawInput
                                          className="border border-gray-400 rounded-md p-2 text-sm pl-12 w-full"
                                          containerClass="w-full"
                                          name="receiverNum"
                                          placeholder="9000000000"
                                          onChange={onReceiverNumChange}
                                          type="text"
                                          autoComplete="off"
                                          value={receiverNum}
                                          maxlength="10"
                                          validation={receiverNumErr}
                                          disabled
                                        />
                                      </Div>
                                    </Div>
                                  </Div>
                                </Div>
                                <Div className="flex flex-col gap-4 mt-6">
                                  <Div className="flex justify-between items-center">
                                    <h2 className="font-bold">Delivery Address</h2>
                                  </Div>
                                  <Div className="grid grid-cols-2 gap-4">
                                    <Div className="flex flex-col">
                                      <Text className="text-secondary-200 text-sm font-semibold" htmlFor="senderFName">
                                        Floor/Unit No. Street Address
                                      </Text>
                                      <RawInput
                                        className="border border-gray-400 rounded-md p-2 text-sm w-full mt-2"
                                        name="receiverStreet"
                                        onChange={onReceiverUnitChange}
                                        placeholder="Floor/Unit No."
                                        value={receiverUnit}
                                        type="text"
                                        autoComplete="off"
                                        validation={receiverUnitErr}
                                        disabled
                                      />
                                    </Div>
                                    <Div className="flex flex-col">
                                      <Text className="text-secondary-200 text-sm font-semibold" htmlFor="senderFName">
                                        Province
                                      </Text>
                                      <RawSelect
                                        id="receiverProvince"
                                        name="receiverProvince"
                                        label=""
                                        placeholder="Province"
                                        containerClass="w-full"
                                        className="border-grey-400 text-secondary-200 text-sm h-10 block w-full mt-2"
                                        classNamePrefix="react-select"
                                        isDisabled={true}
                                        // isDisabled={receiverProvinceData.length === 0}
                                        onChange={(value) =>
                                          onReceiverProvinceChange(deliveryMethod, value)
                                        }
                                        value={receiverProvince}
                                        maxMenuHeight={180}
                                        minHeight={50}
                                        options={receiverProvinceData.map((item) => ({
                                          value: `${item.ProvinceId || item.ProvinceID}`, // convert to string
                                          label: `${item.ProvinceName}`,
                                        }))}
                                        filterOption={filterConfig}
                                        validation={receiverProvinceErr}
                                      />
                                    </Div>
                                    <Div className="flex flex-col">
                                      <Text className="text-secondary-200 text-sm font-semibold" htmlFor="senderFName">
                                        City/Municipality
                                      </Text>
                                      <RawSelect
                                        id="receiverCity"
                                        name="receiverCity"
                                        label=""
                                        placeholder="City/Municipality"
                                        containerClass="w-full"
                                        className="border-grey-400 text-secondary-200 text-sm h-10 block w-full mt-2"
                                        classNamePrefix="react-select"
                                        isDisabled={true}
                                        // isDisabled={receiverCityData.length === 0}
                                        onChange={(value) =>
                                          onReceiverCityChange(
                                            deliveryMethod,
                                            receiverProvince,
                                            value
                                          )
                                        }
                                        value={receiverCity}
                                        maxMenuHeight={180}
                                        minHeight={50}
                                        options={receiverCityData.map((item) => ({
                                          value: `${item.CityId || item.CityID}`,
                                          label: `${item.CityName}`,
                                        }))}
                                        filterOption={filterConfig}
                                        validation={receiverCityErr}
                                      />
                                    </Div>
                                    <Div className="flex flex-col">
                                      <Text className="text-secondary-200 text-sm font-semibold" htmlFor="senderFName">
                                        Barangay
                                      </Text>
                                      <RawSelect
                                        id="receiverBrgy"
                                        name="receiverBrgy"
                                        label=""
                                        placeholder={
                                          deliveryMethod === "HOME DELIVERY"
                                            ? "Barangay"
                                            : "Branch"
                                        }
                                        containerClass="w-full"
                                        className="border-grey-400 text-secondary-200 text-sm h-10 block w-full mt-2"
                                        classNamePrefix="react-select"
                                        isDisabled={true}
                                        // isDisabled={receiverBrgyData.length === 0}
                                        onChange={(value) => onReceiverBrgyChange(value)}
                                        value={receiverBrgy}
                                        maxMenuHeight={180}
                                        minHeight={50}
                                        options={receiverBrgyData.map((item) => ({
                                          value: Number(item.BarangayId || item.BarangayID || item.branchid), // number lang
                                          label: item.BarangayName || item.BranchDescr,
                                        }))}
                                        filterOption={filterConfig}
                                        validation={receiverBrgyErr}
                                      />
                                    </Div>
                                    <Div className="flex flex-col">
                                      <Text className="text-secondary-200 text-sm font-semibold" htmlFor="senderFName">
                                        Nearest Landmark
                                      </Text>
                                      <RawInput
                                        className="border border-gray-400 rounded-md p-2 text-sm w-full mt-2"
                                        name="receiverLandmark"
                                        onChange={setReceiverLandmark}
                                        placeholder="Nearest Landmark"
                                        type="text"
                                        autoComplete="off"
                                        disabled
                                      />
                                    </Div>
                                  </Div>
                                </Div>
                              </div>
                            )}

                            {currentStage === 3 && (
                              <div className="p-6 bg-gray-100 w-full rounded-lg">
                                <h2 className="font-bold text-lg">Delivery Method</h2>
                                <p className="text-gray-600">Kindly review the summary details below before placing your order.</p>
                                <div className="flex gap-6 mt-4">
                                  <div className="w-1/2 bg-white p-6 rounded-lg shadow-lg relative">
                                    <h3 className="font-bold text-lg">Receiver</h3>
                                    <p>{`${receiverFName} ${receiverLName}`}</p>
                                    <p className="text-gray-500">+63 {receiverNum}</p>
                                    <p className="text-gray-500">{receiverUnit}, {receiverBrgy.label}, {receiverCity.label}</p>
                                    <p className="text-gray-500">{receiverProvince.label}</p>
                                    <a 
                                      className="absolute top-4 right-4 font-bold cursor-pointer underline"
                                      style={{ color: '#2563eb' }}
                                      onClick={() => {
                                        setStage(2);
                                        setShowBookingDetails(true);
                                      }}
                                    >
                                      Edit
                                    </a>
                                  </div>
                                  

                                  <div className="w-1/2 bg-white p-6 rounded-lg shadow-lg relative">
                                    <h3 className="font-bold text-lg">Order/s</h3>
                                    {Array.isArray(cartItems) ? cartItems.map((item, index) => (
                                      <React.Fragment key={index}>
                                        <a
                                          className="absolute top-4 right-4 font-bold cursor-pointer underline"
                                          style={{ color: '#2563eb' }}
                                          onClick={() => {
                                            console.log("Clicked item:", item);
                                            handleEditClick(item)
                                          }}
                                        >
                                          Edit
                                        </a>
                                      </React.Fragment>
                                    )) : null}

                                    <div className="mt-4 max-h-60 overflow-y-auto space-y-4">
                                      {Array.isArray(cartItems) &&
                                        cartItems
                                          .filter(
                                            (item) =>
                                              item &&
                                              typeof item === "object" &&
                                              "prodId" in item &&
                                              item.quantity &&
                                              item.price &&
                                              typeof item.price === "object"
                                          )
                                          .map((item, index) => {
                                            const quantity = item.quantity ?? { ncr: 0, outsideNCR: 0 };
                                            const price = {
                                              ncr: item.price?.ncr ?? 0,
                                              outsideNCR: item.price?.outsideNCR ?? 0,
                                            };

                                            const totalQty = quantity.ncr + quantity.outsideNCR;
                                            if (totalQty === 0) return null;

                                            return (
                                              <div key={index} className="flex items-start gap-4">
                                                <img
                                                  src={item.image}
                                                  alt={item.name}
                                                  className="w-16 h-16 object-cover"
                                                />
                                                <div>
                                                  <p className="font-bold">{item.name}</p>
                                                  <p className="text-gray-500 text-sm">
                                                    Quantity: NCR ({quantity.ncr}) / Outside NCR (
                                                    {quantity.outsideNCR})
                                                  </p>
                                                  <p className="text-red-500 font-bold text-sm">
                                                    Total: ₱
                                                    {(
                                                      price.ncr * quantity.ncr +
                                                      price.outsideNCR * quantity.outsideNCR
                                                    ).toLocaleString()}
                                                  </p>
                                                </div>
                                              </div>
                                            );
                                          })}

                                      <p className="font-bold text-right mt-4">
                                        Total: ₱
                                        {Array.isArray(cartItems)
                                          ? cartItems
                                              .filter(
                                                (item) =>
                                                  item &&
                                                  typeof item === "object" &&
                                                  "prodId" in item &&
                                                  item.quantity &&
                                                  item.price &&
                                                  typeof item.price === "object"
                                              )
                                              .reduce((acc, item) => {
                                                const quantity = item.quantity ?? { ncr: 0, outsideNCR: 0 };
                                                const price = {
                                                  ncr: item.price?.ncr ?? 0,
                                                  outsideNCR: item.price?.outsideNCR ?? 0,
                                                };
                                                return (
                                                  acc +
                                                  price.ncr * quantity.ncr +
                                                  price.outsideNCR * quantity.outsideNCR
                                                );
                                              }, 0)
                                              .toLocaleString()
                                          : "0"}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                {purchaseOrder && !showProofUpload && (
                                  <div className="mt-6 bg-white p-6 rounded-lg shadow-lg">
                                    <h3 className="font-bold text-lg mb-4">Payment Method Selected:</h3>

                                    {/* Payment Method Button */}
                                    <button className="w-full p-4 border-2 border-[rgb(208,1,73)] text-[rgb(208,1,73)] rounded-lg flex items-center justify-center gap-2">
                                      <BsCash className="w-6 h-6 text-[rgb(208,1,73)]" />
                                      <span className="font-bold">Paid</span>
                                    </button>

                                    {/* Payment Breakdown */}
                                    <div className="mt-4 space-y-1">
                                      {Array.isArray(cartItems) &&
                                        cartItems
                                          .filter(
                                            (item) =>
                                              item &&
                                              typeof item === "object" &&
                                              item.quantity &&
                                              typeof item.price === "object"
                                          )
                                          .map((item, index) => {
                                            const quantity = {
                                              ncr: item.quantity?.ncr ?? 0,
                                              outsideNCR: item.quantity?.outsideNCR ?? 0,
                                            };

                                            const price = {
                                              ncr: item.price?.ncr ?? 0,
                                              outsideNCR: item.price?.outsideNCR ?? 0,
                                            };

                                            const ncrTotal = price.ncr * quantity.ncr;
                                            const outsideTotal = price.outsideNCR * quantity.outsideNCR;

                                            return (
                                              <React.Fragment key={index}>
                                                {quantity.ncr > 0 && (
                                                  <p>
                                                    {item.name} (To NCR){" "}
                                                    <span className="float-right">₱{ncrTotal.toLocaleString()}</span>
                                                  </p>
                                                )}
                                                {quantity.outsideNCR > 0 && (
                                                  <p>
                                                    {item.name} (Outside NCR){" "}
                                                    <span className="float-right">₱{outsideTotal.toLocaleString()}</span>
                                                  </p>
                                                )}
                                              </React.Fragment>
                                            );
                                          })}
                                    </div>

                                    {/* Total Fee */}
                                    <div className="mt-4 bg-gray-200 p-4 rounded-lg flex justify-between font-bold">
                                      <span>Total Fee</span>
                                      <span>
                                        ₱
                                        {Array.isArray(cartItems)
                                          ? cartItems
                                              .filter(
                                                (item) =>
                                                  item &&
                                                  typeof item === "object" &&
                                                  item.quantity &&
                                                  typeof item.price === "object"
                                              )
                                              .reduce((acc, item) => {
                                                const quantity = {
                                                  ncr: item.quantity?.ncr ?? 0,
                                                  outsideNCR: item.quantity?.outsideNCR ?? 0,
                                                };

                                                const price = {
                                                  ncr: item.price?.ncr ?? 0,
                                                  outsideNCR: item.price?.outsideNCR ?? 0,
                                                };

                                                return (
                                                  acc + price.ncr * quantity.ncr + price.outsideNCR * quantity.outsideNCR
                                                );
                                              }, 0)
                                              .toLocaleString()
                                          : "0"}
                                      </span>
                                    </div>
                                  </div>
                                )}

                                {!purchaseOrder && !showProofUpload && (
                                  <>
                                    <div className="mt-6 bg-white p-6 rounded-lg shadow-lg">
                                      <h3 className="font-bold text-lg">Select payment method:</h3>
                                      <div className="flex gap-4 mt-4">
                                        <button
                                          className={`w-1/4 p-4 border-2 rounded-lg flex items-center justify-center gap-2 transition-all duration-300 ${
                                            selectedPayment === "Cash"
                                              ? "bg-[rgb(208,1,73)] text-white border-[rgb(208,1,73)]"
                                              : "text-[rgb(208,1,73)] border-gray-300 bg-white"
                                          }`}
                                          onClick={() => setSelectedPayment("Cash")}
                                        >
                                          <BsCash
                                            className={`w-6 h-6 ${
                                              selectedPayment === "Cash" ? "text-white" : "text-[rgb(208,1,73)]"
                                            }`}
                                          />
                                          Paid
                                        </button>
                                        <button 
                                          className="w-1/4 p-4 border-2 border-gray-300 text-gray-400 rounded-lg flex items-center justify-center gap-2 cursor-not-allowed opacity-50 backdrop-blur-sm" 
                                          disabled
                                        >
                                          <IoQrCodeSharp className="w-6 h-6 text-[rgb(208,1,73)]" />
                                          Scan QR
                                        </button>
                                        <button 
                                          className="w-1/4 p-4 border-2 border-gray-300 text-gray-400 rounded-lg flex items-center justify-center gap-2 cursor-not-allowed opacity-50 backdrop-blur-sm" 
                                          disabled
                                        >
                                          <FaCreditCard alt="Debit/Credit" className="w-6 h-6 text-[rgb(208,1,73)]" />
                                          Debit / Credit
                                        </button>
                                        <button 
                                          className="w-1/4 p-4 border-2 border-gray-300 text-gray-400 rounded-lg flex items-center justify-center gap-2 cursor-not-allowed opacity-50 backdrop-blur-sm" 
                                          disabled
                                        >
                                          <TfiWallet alt="E-Wallet" className="w-6 h-6 text-[rgb(208,1,73)]" />
                                          E-Wallet
                                        </button>
                                      </div>
                                      <div className="mt-6">
                                        <div className="mt-4">
                                          {Array.isArray(cartItems) &&
                                            cartItems
                                              .filter(
                                                (item) =>
                                                  item &&
                                                  typeof item === "object" &&
                                                  "prodId" in item &&
                                                  item.quantity &&
                                                  item.price &&
                                                  typeof item.price === "object"
                                              )
                                              .map((item, index) => {
                                                const quantity = item.quantity ?? { ncr: 0, outsideNCR: 0 };
                                                const price = {
                                                  ncr: item.price?.ncr ?? 0,
                                                  outsideNCR: item.price?.outsideNCR ?? 0,
                                                };

                                                const ncrTotal = price.ncr * quantity.ncr;
                                                const outsideTotal = price.outsideNCR * quantity.outsideNCR;

                                                return (
                                                  <React.Fragment key={index}>
                                                    {quantity.ncr > 0 && (
                                                      <p>
                                                        {item.name} (To NCR)
                                                        <span className="float-right">₱{ncrTotal.toLocaleString()}</span>
                                                      </p>
                                                    )}
                                                    {quantity.outsideNCR > 0 && (
                                                      <p>
                                                        {item.name} (Outside NCR)
                                                        <span className="float-right">₱{outsideTotal.toLocaleString()}</span>
                                                      </p>
                                                    )}
                                                  </React.Fragment>
                                                );
                                              })}
                                        </div>

                                        <div className="mt-4 bg-gray-200 p-4 rounded-lg flex justify-between font-bold">
                                          <span>Total Fee</span>
                                          <span>
                                            ₱
                                            {Array.isArray(cartItems)
                                              ? cartItems
                                                  .filter(
                                                    (item) =>
                                                      item &&
                                                      typeof item === "object" &&
                                                      "prodId" in item &&
                                                      item.quantity &&
                                                      item.price &&
                                                      typeof item.price === "object"
                                                  )
                                                  .reduce((acc, item) => {
                                                    const quantity = item.quantity ?? { ncr: 0, outsideNCR: 0 };
                                                    const price = {
                                                      ncr: item.price?.ncr ?? 0,
                                                      outsideNCR: item.price?.outsideNCR ?? 0,
                                                    };
                                                    return (
                                                      acc +
                                                      price.ncr * quantity.ncr +
                                                      price.outsideNCR * quantity.outsideNCR
                                                    );
                                                  }, 0)
                                                  .toLocaleString()
                                              : "0"}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}

                                {showProofUpload && (
                                  <div className="mt-6 bg-white p-6 rounded-lg shadow-lg">
                                    <h3 className="text-lg font-bold mb-2">Proof of Payment</h3>
                                    <p className="text-sm text-gray-600 mb-4">
                                      If you have already paid for your order, upload a clear and accurate picture of the receipt.
                                    </p>

                                    {/* Upload Area - hide this if proofFile is already uploaded */}
                                    {!proofFile && (
                                      <div className="border-2 border-dashed border-gray-300 rounded-md p-8 text-center bg-gray-50">
                                        <label htmlFor="file-upload" className="cursor-pointer flex flex-col items-center">
                                          <svg className="w-10 h-10 text-gray-400 mb-3" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M12 12v9m0 0l-3-3m3 3l3-3M12 3v9" />
                                          </svg>
                                          <span className="text-gray-700 text-sm mb-1">Upload the Proof of Payment</span>
                                          <span className="text-xs text-gray-500 mb-4">
                                            Please make sure to upload a clear and accurate picture of the receipt here.
                                          </span>
                                          <input type="file" accept="image/*" onChange={handleFileChange} />
                                          <span className="text-sm text-gray-600">
                                            Drag and drop .jpeg, .png or <span className="text-blue-600 underline">browse</span>
                                          </span>
                                        </label>
                                      </div>
                                    )}

                                    {/* File Preview */}
                                    {proofFile && (
                                      <div className="mt-4 flex items-center justify-between bg-blue-100 text-blue-700 px-4 py-2 rounded-md w-full max-w-md">
                                        <div className="flex items-center space-x-2">
                                          <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M4 2a2 2 0 00-2 2v12a2 2 0 002 2h7.586a2 2 0 001.414-.586l4.414-4.414A2 2 0 0018 12.414V4a2 2 0 00-2-2H4z" />
                                          </svg>
                                          <span className="text-sm font-medium">{proofFile.name}</span>
                                        </div>
                                        <button
                                          onClick={() => {
                                            setProofFile(null);
                                            setProofFileBase64(null);
                                          }}
                                          className="ml-4 text-blue-700 hover:text-red-600 font-bold text-lg leading-none"
                                          title="Remove file"
                                        >
                                          &times;
                                        </button>
                                      </div>
                                    )}

                                    {/* Back button */}
                                    <div className="mt-4 text-right">
                                      <button
                                        onClick={() => setShowProofUpload(false)}
                                        style={{
                                          color: "blue",
                                          textDecoration: "underline",
                                          background: "transparent",
                                          border: "none",
                                          padding: 0,
                                          font: "inherit",
                                          cursor: "pointer",
                                        }}
                                      >
                                        Back to Payment Method
                                      </button>
                                    </div>
                                  </div>
                                )}

                                {purchaseOrder && !showProofUpload && (
                                  <div className="mt-4 text-right">
                                    <button
                                      onClick={() => setShowProofUpload(true)}
                                      className="text-blue-600 underline hover:underline bg-transparent p-0 m-0"
                                      style={{
                                        color: "blue",
                                        textDecoration: "underline",
                                        background: "transparent",
                                        border: "none",
                                        padding: 0,
                                        font: "inherit",
                                        cursor: "pointer",
                                      }}
                                    >
                                      I already paid for my order
                                    </button>
                                  </div>
                                )}
                              </div>
                            )}

                            <FlexRow className="w-full items-start justify-center py-2">
                              {currentStage > 2 && (
                                <RawButton
                                  className="w-1/4"
                                  onClick={() => setToastOpen1(true)}
                                >
                                  <Text className="text-red-400 font-bold">
                                    Save for later
                                  </Text>
                                </RawButton>
                              )}
                              <Spacer className="w-1/2" />
                              <Button
                                className="w-1/4 mr-2 phone:bg-white phone:text-secondary-200 hover:bg-grey-500 phone:border phone:border-grey-400 h-10"
                                onClick={() => {
                                  if (currentStage === 2) {
                                    setShowPromptTab(true);
                                  } else {
                                    onChangeStage(currentStage, "prev");
                                  }
                                }}
                              >
                                {currentStage === 2 ? "Cancel" : "Back"}
                              </Button>

                              <Button
                                className="w-1/4 ml-2 h-10"
                                onClick={() => {
                                  if (purchaseOrder) {
                                    // setConfirmBooking(true);
                                    onSaveOrder();
                                    // sendEmailConfirmation(bulkSessionId);
                                  } else {
                                    onChangeStage(currentStage, "next");
                                  }
                                }}
                                disabled={(currentStage > 2 && !selectedPayment) || loading || (purchaseOrder && !isValidImage) }
                              >
                                {purchaseOrder ? "Purchase Now" : "Next"}
                              </Button>
                            </FlexRow>
                          </div>
                        </div>
                      </div>
                    </Tab.Panels>
                  </FlexRow>
                </Div>
              </FlexRow>
            </>
          )}
        </>
      ) : (
        <>
          <Spacer className="h-4" />

          {open && (
            <div className="fixed inset-0 z-50">
              <CartModal open={open} setOpen={setOpen} cartItems={cartItems} setCartItems={setCartItems} onOrderNow={OrderHandled} data={{ bulkSessionId: bulkSessionId, editItem: selectedItem }}  />
            </div>
          )}

          <div className="relative w-full rounded-b-2xl shadow-md">
            <img
              src={Path1}
              alt="Top Decoration"
              className="absolute top-0 right-0 max-w-none h-auto"
              style={{ width: '250px', zIndex: 2 }}
            />

            <img
              src={Path2}
              alt="Bottom Decoration"
              className="absolute bottom-0 left-0 max-w-none h-auto"
              style={{ width: '250px', zIndex: 1 }}
            />

            <FlexRow className="justify-between w-full items-center px-5 py-3 relative z-20">
              <Text className="text-black font-bold text-2xl">
                LBC SendTipid Packages
              </Text>

              <Div
                className="absolute right-10 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow-lg"
                onClick={() => setOpen(true)}
              >
                <RiShoppingCart2Line className="w-7 h-7 text-[rgb(208,1,73)] cursor-pointer" />
              </Div>

              {/* <div className="absolute right-10 top-12 z-50">
                {open && <CartModal open={open} setOpen={setOpen} onOrderNow={handleOrderNow} />}
              </div> */}
            </FlexRow>

            {/* Main Content Section */}
            <FlexRow
              className="flex flex-wrap justify-center gap-7 mt-8 relative z-30"
            >
              {/* {packages.map((pkg, index) => (
                <PackageCard key={index} {...pkg} />
              ))} */}

              {pkgData.map((pkg, index) => {
                const packageImage = Images.getPackageImageSendTipid(pkg.prodId);
                return (
                  <PackageCard
                    key={pkg.prodId}
                    image={Images.getPackageImageSendTipid(pkg.prodId)}
                    title={pkg.prodDisplayName}
                    weight={pkg.weight}
                    NCRPrice={pkg.NCRPrice}
                    OutSideNCR={pkg.OutSideNCR}
                    Description={pkg.description}
                    onOrderNow={() => {
                      setSelectedPackage({
                        ...pkg,
                        image: Images.getPackageImageSendTipid(pkg.prodId),
                      });
                      setOpenOrderModal(true); // 🔥 Open modal
                    }}
                  />
                );
              })}

              {openOrderModal && selectedPackage && (
                <OrderModal
                  isOpen={openOrderModal}
                  onClose={() => setOpenOrderModal(false)}
                  packageData={selectedPackage}
                  onAddToCart={handleAddToCart}
                />
              )}

            </FlexRow>

            <Spacer className="h-2" />
          </div>
          
          <Spacer className="h-3" />

          <FlexRow className="justify-between w-full items-center px-5 py-3 relative">
            <div className="md:w-1/2 w-full flex justify-center">
              <img
                src={LogoLBC}
                alt="LBC Delivery"
                className="w-full max-w-sm object-contain"
              />
            </div>

            <div className="md:w-1/2 w-full flex flex-col">
              <Text className="text-black font-bold text-2xl">
                Deliver your SendTipid package in 4 easy steps:
              </Text>

              <div className="grid grid-cols-2 gap-6 p-4">
                {/* Step 1 */}
                <div className="bg-white shadow-md rounded-2xl p-6">
                  <div className="text-red-600 text-2xl mb-3">
                    <FaBox className="w-7 h-7 text-[rgb(208,1,73)]" />
                  </div>
                  <h3 className="text-lg font-bold mb-2">Step 1: Buy Packaging</h3>
                  <p className="text-sm text-gray-700">
                    Order a bundle (25 pcs) of package of your choice by clicking{' '}
                    <span className="text-blue-600 underline cursor-pointer" >
                      'Add to Bag'
                    </span>
                    Available in different sizes for more options.
                  </p>
                </div>

                {/* Step 2 */}
                <div className="bg-white shadow-md rounded-2xl p-6">
                  <div className="text-red-600 text-2xl mb-3">
                    <FaStore className="w-7 h-7 text-[rgb(208,1,73)]" />
                  </div>
                  <h3 className="text-lg font-bold mb-2">Step 2: Book via CAP (Corporate Account Portal)</h3>
                  <p className="text-sm text-gray-700">
                    You can book online using your access in CAP.
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-6 p-4">
                <div className="bg-white shadow-md rounded-2xl p-6">
                  <div className="text-red-600 text-2xl mb-3">
                    <FaRegBookmark className="w-7 h-7 text-[rgb(208,1,73)]" />
                  </div>
                  <h3 className="text-lg font-bold mb-2">Step 3: Track your package</h3>
                  <p className="text-sm text-gray-700">
                    You can track your package using our Track and Trace tool to monitor its journey with LBC. Simply enter the tracking number in the Track and Trace system.
                  </p>
                </div>

                <div className="bg-white shadow-md rounded-2xl p-6">
                  <div className="text-red-600 text-2xl mb-3">
                    <FaTruck className="w-7 h-7 text-[rgb(208,1,73)]" />
                  </div>
                  <h3 className="text-lg font-bold mb-2">Step 4: Delivery successfully</h3>
                  <p className="text-sm text-gray-700">
                    Your package will reach the recipient safely within 1–3 days, depending on distance and weather conditions.
                  </p>
                </div>
              </div>
            </div>
          </FlexRow>
        </>
      )}
    </>
  );
};
